import { render, staticRenderFns } from "./BadgeNotificationTemplate.vue?vue&type=template&id=7280f17c&scoped=true&"
import script from "./BadgeNotificationTemplate.vue?vue&type=script&lang=js&"
export * from "./BadgeNotificationTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BadgeNotificationTemplate.vue?vue&type=style&index=0&id=7280f17c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7280f17c",
  null
  
)

export default component.exports